import { Trash2, X } from 'lucide-react';
import { tileState } from './TicketTiles';

// Sticky bar for picking many tickets and deleting them together.
export default function BulkDeleteBar({ tickets, selected, setSelected, onDelete, onCancel }) {
  const lostIds = tickets.filter((t) => tileState(t).lost).map((t) => t.id);
  const btn = 'rounded-full px-3 py-1.5 text-xs font-semibold transition-colors';
  return (
    <div className="sticky top-2 z-30 rounded-xl border border-red-500/40 bg-zinc-950/95 backdrop-blur-md p-2.5 flex flex-wrap items-center gap-2 shadow-xl" data-testid="bulk-bar">
      <p className="text-sm font-bold text-white mr-auto" data-testid="bulk-count">{selected.size} selected</p>
      <button type="button" className={`${btn} bg-zinc-800 text-zinc-200 hover:bg-zinc-700`} data-testid="bulk-select-lost"
        onClick={() => setSelected(new Set(lostIds))}>All lost ({lostIds.length})</button>
      <button type="button" className={`${btn} bg-zinc-800 text-zinc-200 hover:bg-zinc-700`} data-testid="bulk-select-all"
        onClick={() => setSelected(selected.size === tickets.length ? new Set() : new Set(tickets.map((t) => t.id)))}>
        {selected.size === tickets.length ? 'None' : 'All'}
      </button>
      <button type="button" disabled={!selected.size} onClick={onDelete} data-testid="bulk-delete-btn"
        className={`${btn} bg-red-600 text-white hover:bg-red-500 disabled:opacity-40 flex items-center gap-1`}>
        <Trash2 className="w-3.5 h-3.5" /> Delete {selected.size || ''}
      </button>
      <button type="button" onClick={onCancel} aria-label="Cancel" data-testid="bulk-cancel" className="rounded-full bg-zinc-800 p-1.5 text-zinc-300 hover:bg-zinc-700"><X className="w-4 h-4" /></button>
    </div>
  );
}
